
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore-art/art-for-all",
      function () {
        return require("private-next-pages/explore-art/art-for-all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore-art/art-for-all"])
      });
    }
  